import { captureErrorAndNotify } from '../../utilities/errorHandlers'

export async function exportTransactionToQBO (invoice, transaction, exportPaymentToQuickbooks, exportRefundToQuickbooks) {
  switch (transaction.transactionType) {
    case 'SALE':
      if (transaction.provider === 'DISPATCHER') {
        return await exportPaymentToQuickbooks({ invoiceId: invoice.id, dispatcherPaymentId: transaction.id })
      }
      return await exportPaymentToQuickbooks({ invoiceId: invoice.id, transactionId: transaction.id })
    case 'RETURN':
      if (transaction.provider === 'DISPATCHER') {
        return await exportRefundToQuickbooks({ invoiceId: invoice.id, dispatcherRefundId: transaction.id })
      }
      return await exportRefundToQuickbooks({ invoiceId: invoice.id, transactionId: transaction.id })
    default: {
      const error = new Error('Unhandled transaction type to export to QuickBooks')
      captureErrorAndNotify(error, 'Unable to export transaction to QuickBooks')
    }
  }
}
